<template>
  <!-- 运费支付 -->
 <div >
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" ref="" class="demo-form-inline" label-width="110px" size="mini">
        <div class="searchBox inpBox">
            <div class="item">
               <el-form-item label="业务单号:" prop="businessNo">
                <el-input  placeholder="" v-model="searchFrom.businessNo"></el-input>
              </el-form-item>
              <el-form-item label="订单号:" prop="orderNo">
                <el-input  placeholder="" v-model="searchFrom.orderNo"></el-input>
              </el-form-item>
              <el-form-item label="收款人:" prop="payee">
                <el-input  placeholder="" v-model="searchFrom.payee"></el-input>
              </el-form-item>

               <el-form-item label="身份证号:" prop="payeeIdentityNo">
                <el-input  placeholder="" v-model="searchFrom.payeeIdentityNo" maxlength="18"></el-input>
              </el-form-item>
              <el-form-item label="年月:" prop="settlementDate">
               <el-date-picker
                      v-model="searchFrom.settlementDate"
                      :editable="false"
                      :clearable="false"
                      type="month"
                      format="yyyy-MM"
                      value-format="yyyy-MM"
                      placeholder="选择月">
              </el-date-picker>
              </el-form-item>

            </div>
        </div>
       <div class="searchBtnBox">
           <el-form-item btnCode="00JP009B001" >
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
           <el-form-item v-if="btnFlg[0]">
            <el-button type="primary" @click="yunsuanFn">运算</el-button>
          </el-form-item>
           <el-form-item >
            <el-button type="primary" @click="exportFn" :disabled="isDisable">导出</el-button>
          </el-form-item>
          <!-- <el-form-item >
            <el-button type="primary" @click="tuisongFn">推送临时纳税人信息</el-button>
          </el-form-item> -->
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' height="100%" style="width: 100%" center border>
        <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
         <el-table-column property="businessNo" width="200"  :formatter="emptyFn"   label="业务单号"></el-table-column>
         <el-table-column property="orderNo" width="200"  :formatter="emptyFn"   label="订单号"></el-table-column>
        <el-table-column property="payee"  width="120"  :formatter="emptyFn"   label="收款人"></el-table-column>
        <el-table-column property="payeeIdentityNo"  width="200"  :formatter="emptyFn"   label="身份证号码"></el-table-column>
        <el-table-column property="fatePrice"  width="120"  :formatter="emptyFn"   label="运费"></el-table-column>
        <el-table-column property="taxableIncome"  width="200"  :formatter="emptyFn"   label="应税收入"></el-table-column>
        <el-table-column property="taxBasis"  width="150"  :formatter="emptyFn"   label="计税依据"></el-table-column>
        <el-table-column property="taxPayable"  width="120"  :formatter="emptyFn"   label="应纳税额"></el-table-column>
        <el-table-column property="taxRate"  width="120"  :formatter="emptyFn"   label="税率(速算表)"></el-table-column>
        <el-table-column property="quickCalculationDeduction"  width="120"  :formatter="emptyFn"   label="速算扣除数"></el-table-column>
        <el-table-column width="170" property="accumulatedTaxPaid" :formatter="emptyFn" label="累计已缴税额"></el-table-column>
         <el-table-column property="taxReimbursement"  width="120"  :formatter="emptyFn"   label="本期应补退税额"></el-table-column>
        <el-table-column property="stampDuty"  width="120"  :formatter="emptyFn"   label="印花税"></el-table-column>
        <el-table-column property="valueAddedTax"  width="120"  :formatter="emptyFn"   label="增值税"></el-table-column>
        <el-table-column width="170" property="urbanConstructionTax" :formatter="emptyFn" label="城建税"></el-table-column>
        <el-table-column property="educationSurtax"  width="120"  :formatter="emptyFn"   label="教育费附加"></el-table-column>
        <el-table-column width="170" property="localEducationSurtax" :formatter="emptyFn" label="地方教育费附加"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
      <el-dialog :title="title"  :visible.sync="SQMark" width="450px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="SQFrom" ref="SQFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="145px" size="mini">
        <div class="inpBox1">
            <div style="margin: 28px 0;">
              <!-- <el-form-item label="年月:" prop="taxDate" class="inpBox2">
                <el-date-picker
                  v-model="SQFrom.taxDate"
                  format="yyyy-MM"
                  value-format="yyyy-MM"
                  placeholder="选择日期"
                ></el-date-picker>
            </el-form-item> -->
             <el-form-item label="年月:" prop="taxDate">
               <el-date-picker
                      v-model="SQFrom.taxDate"
                      :editable="false"
                      :clearable="false"
                      type="month"
                      format="yyyy-MM"
                      value-format="yyyy-MM"
                      placeholder="选择月">
              </el-date-picker>
              </el-form-item>
             </div>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SQMark = false">取消</el-button>
        <el-button type="primary" @click="SQsave()">确定</el-button>
      </span>
   </el-dialog>
 </div>

</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat } from '@/utils/util'
import {
  sTaxationDetailList, // 列表
  sTaxationSummaryAdd // 运算
  // reportTemporaryTaxpayerInfo
} from '@/api/consignment'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  data () {
    return {
      title: '',
      SQFrom: {},
      SQMark: false,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      h: '500px',
      // 查询调价
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      loading: 'false',
      total: 0,
      rules: {
        reason: { required: true, message: '请输入拒绝原因', trigger: 'blur' },
        taxDate: { required: true, message: '请选择年月', trigger: 'blur' }
      },
      isDisable: false,
      btnFlg: [],
      btnIdArr: ['00JP00KB001']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/paymenWithholding/waybillTax')
    this.$set(this.searchFrom, 'settlementDate', this.getLastMonth())
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 92) + 'px'
  },
  methods: {
    // tuisongFn () {
    //   this.SQMark = true
    //   this.title = '推送临时纳税人信息'
    // },
    // SQsave () {
    //   this.$refs.SQFrom.validate((valid) => {
    //     if (valid) {
    //       const loading = this.$loading({
    //         lock: true,
    //         text: '正在处理...'
    //       })
    //       reportTemporaryTaxpayerInfo(this.SQFrom).then(res => {
    //         loading.close()
    //         this.$message({
    //           message: '成功',
    //           type: 'success'
    //         })
    //         this.SQMark = false
    //         this.getList(this.searchFrom)
    //       }).catch(error => {
    //         this.$message({
    //           showClose: true,
    //           message: error.message,
    //           type: 'error',
    //           onClose () {
    //             loading.close()
    //           }
    //         })
    //       })
    //     }
    //   })
    // },
    // 导出
    exportFn () {
      let from = JSON.parse(JSON.stringify(this.searchFrom))
      exportExcel(
        this.global.payName + '/sTaxationDetail/exportList',
        from,
        '运单税费'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 运算
    yunsuanFn () {
      this.$confirm('是进行' + this.getLastMonth() + '的单据运算?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        sTaxationSummaryAdd().then(res => {
          loading.close()
          this.$message({
            message: '成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      sTaxationDetailList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    billDetails (row) {
      this.$router.push({ name: 'billDetails', query: { billId: row.id } })
    },
    // 获取年月
    getLastMonth () { // 获取上个月日期
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() < 10 ? '0' + date.getMonth() : date.getMonth()
      if (month == 0) {
        year = year - 1
        month = 12
      }
      return year + '-' + month
    },
    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        settlementDate: this.getLastMonth()
      }
    },
    closeDialog () {
      this.addForm = {}
      this.CHFrom = {}
      this.SQFrom = {
      }
    }
  }
}
</script>

<style scoped lang='less'>
.inpBox .el-date-editor{
      width: 350px!important;
}
/deep/.inpBox1 .el-input__inner {
    width: 180px;
}
</style>
